export default __webpack_public_path__ + "assets/img/close-dialog-btn.svg";